import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/base/Button';

export default function LoginPage() {
  const [formData, setFormData] = useState({
    email: 'admin@takeya.com'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
    setSuccess('');
  };

  const createAdminSession = (email: string) => {
    // Generate admin session sederhana
    const adminSession = {
      user_id: 'admin-' + btoa(email).replace(/[^a-zA-Z0-9]/g, ''),
      email: email,
      role: 'super_admin',
      name: 'Administrator',
      timestamp: Date.now(),
      active: true
    };

    localStorage.setItem('takeya_admin_session', JSON.stringify(adminSession));
    return adminSession;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await loginProcess(formData.email);
  };

  const quickLogin = async () => {
    await loginProcess('admin@takeya.com');
  };

  const loginProcess = async (email: string) => {
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      // Validasi email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        throw new Error('Format email tidak valid');
      }

      // Daftar email admin yang diizinkan
      const allowedAdminEmails = [
        'admin@takeya.com',
        'manager@takeya.com',
        'owner@takeya.com'
      ];

      // Cek apakah email termasuk admin yang diizinkan
      const isAdminEmail = allowedAdminEmails.includes(email.toLowerCase()) || 
                          email.toLowerCase().includes('admin') ||
                          email.toLowerCase().includes('manager') ||
                          email.toLowerCase().includes('owner');

      if (!isAdminEmail) {
        throw new Error('Email ini tidak memiliki akses admin');
      }

      // Buat session admin langsung tanpa password
      const adminSession = createAdminSession(email);

      console.log('Admin session created:', adminSession);

      setSuccess('Login berhasil! Mengalihkan ke panel admin...');
      
      // Delay sebentar untuk user experience
      setTimeout(() => {
        navigate('/admin');
      }, 1000);

    } catch (err: any) {
      console.error('Login error:', err);
      setError(err.message || 'Terjadi kesalahan saat login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-red-900 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="w-20 h-20 bg-gradient-to-br from-red-600 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-2xl">
            <span className="text-white font-black text-3xl" style={{ fontFamily: '"Noto Sans JP", serif' }}>
              竹
            </span>
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">TAKEYA Admin</h1>
          <p className="text-gray-300">Panel Administrator</p>
        </div>

        {/* Login Form */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl border border-white/20 p-8 shadow-2xl">
          {error && (
            <div className="bg-red-500/20 border border-red-500 rounded-lg p-3 text-red-300 text-sm mb-6 text-center">
              {error}
            </div>
          )}

          {success && (
            <div className="bg-green-500/20 border border-green-500 rounded-lg p-3 text-green-300 text-sm mb-6 text-center">
              {success}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Email Admin"
                className="w-full px-4 py-3 bg-white/10 border border-white/30 rounded-lg text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-red-500"
                required
              />
            </div>

            <Button
              type="submit"
              variant="primary"
              size="lg"
              disabled={loading}
              className="w-full whitespace-nowrap cursor-pointer"
            >
              {loading ? 'Masuk...' : 'Masuk Admin'}
            </Button>
          </form>

          {/* Back to Home */}
          <div className="mt-6 text-center">
            <button
              onClick={() => navigate('/')}
              className="text-gray-300 hover:text-white text-sm transition-colors cursor-pointer"
            >
              ← Kembali ke Beranda
            </button>
          </div>
        </div>

        {/* Instructions */}
        <div className="mt-6 p-4 bg-green-500/20 rounded-lg border border-green-500/30">
          <div className="text-green-300 text-sm text-center">
            <div className="font-semibold mb-2">✅ Cara Login:</div>
            <div className="space-y-1 text-xs">
              <div>1. Masukkan email admin yang valid</div>
              <div>2. Klik "Masuk Admin"</div>
              <div>3. Sistem langsung verifikasi tanpa password</div>
              <div>4. Langsung masuk ke panel admin!</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
